import { Icon } from './types';

export const PhoneIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M22.716 15.566l-4.772-2.047a2.141 2.141 0 00-2.473.613l-1.553 1.897a14.749 14.749 0 01-5.874-5.873l1.9-1.555a2.111 2.111 0 00.601-2.477L8.503 1.352A2.13 2.13 0 006.075.123L1.649 1.15A2.109 2.109 0 000 3.215C0 14.713 9.356 24.07 20.855 24.07c.995 0 1.847-.677 2.07-1.647l1.022-4.428a2.132 2.132 0 00-1.231-2.428zm-1.252 6.52a.63.63 0 01-.608.484C10.182 22.57 1.5 13.888 1.5 3.215c0-.29.198-.538.485-.604L6.41 1.584a.627.627 0 01.714.36l2.043 4.768a.628.628 0 01-.177.73L6.623 9.383a.749.749 0 00-.196.91 16.236 16.236 0 007.354 7.354c.311.155.69.072.912-.198l1.94-2.367a.633.633 0 01.726-.18l4.763 2.042c.276.12.429.42.361.713l-1.019 4.43z'
      }
    />
  </svg>
);
